const o=()=>{};export{o as noop};